import { UnicodeEntity } from '@mews/enums';
import { ConvertedCurrencyValue, LocalizedDateTimeFromUtc } from '@mews-commander/ui';
import { ProductOrderLabel } from '../../../../components/commander-ui';
import { ProductOrder } from '../../transformProductOrders/types';
import { ItemsTableCellElement, ItemsTableRowElement } from './styles';
import { GroupCost } from './GroupCost';
import { ProductOrderBillCancelCell } from './ProductOrderBillCancelCell';
import { formatOrderItemMultipliers } from './utils';

export const ProductOrderItemRow: React.FC<ProductOrderItemRowProps> = ({
    cancelProductOrder,
    isMultiTaxEnvironment,
    order,
    groupId,
    accountId,
    timeUnitKey,
    depth = 0,
    isSingleOrderGroup = false,
}) => {
    const { consumptionUtc, multipliers, unitAmount, data } = order;
    return (
        <ItemsTableRowElement>
            <ItemsTableCellElement offset={depth}>
                {isSingleOrderGroup && (
                    <ProductOrderLabel productId={data.value.productId} ageCategoryId={data.value.ageCategoryId} />
                )}
            </ItemsTableCellElement>
            <ItemsTableCellElement>
                {isSingleOrderGroup ? (
                    <GroupCost
                        multipliers={multipliers}
                        amount={unitAmount}
                        timeUnitKey={timeUnitKey}
                        net={isMultiTaxEnvironment}
                    />
                ) : (
                    <>
                        {formatOrderItemMultipliers(multipliers)}
                        {UnicodeEntity.NoBreakSpace}
                        <ConvertedCurrencyValue amount={unitAmount} net={isMultiTaxEnvironment} />
                    </>
                )}
            </ItemsTableCellElement>
            <ItemsTableCellElement>
                {consumptionUtc ? <LocalizedDateTimeFromUtc utcString={consumptionUtc} /> : null}
            </ItemsTableCellElement>
            <ProductOrderBillCancelCell
                cancelProductOrder={cancelProductOrder}
                order={order}
                groupId={groupId}
                accountId={accountId}
            />
        </ItemsTableRowElement>
    );
};

interface ProductOrderItemRowProps {
    order: ProductOrder;
    cancelProductOrder: (id: string) => void;
    isMultiTaxEnvironment: boolean;
    groupId: string;
    accountId: string;
    timeUnitKey: Mews.TextKey;
    depth?: number;
    isSingleOrderGroup?: boolean;
}
